import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';
import { makeStyles, Theme } from '@material-ui/core/styles';

export const useToggleStyles = makeStyles<Theme>(() => ({
  root: {
    width: 48,
    height: 28,
    padding: 0,
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent',
    },
  },
  switchBase: {
    padding: 3,
    '&$checked': {
      transform: 'translateX(20px)',
      color: `${colors.WHITE}`,
      '& + $track': {
        backgroundColor: `${colors.ALR1}`,
        opacity: 1,
        border: 'none',
      },
    },
  },
  thumb: {
    width: 22,
    height: 22,
    borderRadius: 11,
    boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.2)',
  },
  track: {
    borderRadius: 60,
    backgroundColor: `${colors.G1}`,
    opacity: 1,
  },
  checked: {},
}));

const styles = css`
  .toggle-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    padding: 8px 16px;
  }
  .toggle-label {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
  }
`;
export default styles;
